import axios from "axios";

const STORAGE_TOKEN_KEY = "warranty.token";
const STORAGE_USER_KEY = "warranty.user";

export const baseURL =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:3000";

if (!process.env.REACT_APP_API_URL && !process.env.REACT_APP_API_BASE_URL) {
  console.warn(
    "[api/client] REACT_APP_API_URL no definida; usando fallback",
    baseURL
  );
}

export const apiClient = axios.create({
  baseURL,
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(STORAGE_TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      try {
        localStorage.removeItem(STORAGE_TOKEN_KEY);
        localStorage.removeItem(STORAGE_USER_KEY);
      } catch {}
    }
    return Promise.reject(error);
  }
);

export function setAuth(token, user) {
  if (token) localStorage.setItem(STORAGE_TOKEN_KEY, token);
  else localStorage.removeItem(STORAGE_TOKEN_KEY);
  if (user) localStorage.setItem(STORAGE_USER_KEY, JSON.stringify(user));
  else localStorage.removeItem(STORAGE_USER_KEY);
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(STORAGE_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getStoredToken() {
  return localStorage.getItem(STORAGE_TOKEN_KEY);
}

export function clearAuth() {
  localStorage.removeItem(STORAGE_TOKEN_KEY);
  localStorage.removeItem(STORAGE_USER_KEY);
}

export const STORAGE_KEYS = {
  token: STORAGE_TOKEN_KEY,
  user: STORAGE_USER_KEY,
};
